<p>Visual Breakup of PAHAF Status with respect to the number of Member ID</p>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-5">
      <div class="col-12 p-2">
        <h6 class="mb-3">Filter by PCP</h6>
        <form [formGroup]="">
          <select name="" id="chartdropdownid" class="form-select" (change)="selectedPCP($event)">
            <option value="">Choose PCP</option>
            <!-- <option *ngFor="let pcpname of dropdownPCPList" [ngValue]="pcpname" value ="pcpname.id"> -->
            @for (pcpname of dropdownPCPList; track pcpname) {
              <option [value] ="pcpname.id">
                {{ pcpname.itemName }}
              </option>
            }
          </select>
        </form>
      </div>
    </div>
  </div>
  <br>
    <!-- <br>   -->
    <div class="row">
      <div class="col-md-9" style="height: 403px;">
        <div class="row">
          <div class="col-md-12 text-center">
            PAHAF Status
          </div>
        </div>
        <br>
          <div class="row">
            <div class="col-md-12">
              <div class="mt-0 pb-1">
                <div style="display : block">
                  <ngx-charts-pie-chart [results] = "pieChartData"
                    [view] = "view"
                    [legend]="showLegend"
                    [legendPosition] = "legendPosition"
                    [labels] = "showLabels"
                    [scheme]="colorScheme"
                    [trimLabels]="trimlabel"
                  ></ngx-charts-pie-chart>
                  <!-- <canvas
                  baseChart
                  [datasets]="pieChartData"
                  [labels]="pieChartLabels"
                  [options]="options"
                  [legend]= "true"
                  [colors]="pieChartColor"
                  (chartClick)="onChartClick($event)"
                  [chartType]="pieChartType">
                </canvas> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3" style="border-style: dotted;border-width: 2px;border-color: #23499E;border-radius: 10px;">
        <div class="col-12">
          <div class="row">
            <div class="text-center" style="padding:10px">
              <h5 style="font-size: 1.1rem;">{{tempdp}}</h5>
            </div>
            <div class="col-12">
              <div class="text-center" style="background-color:lightgray;padding:10px;">
                <h6 class="m-0 p-0" style="font-size: 0.9rem;">Member Counts</h6>
              </div>
            </div>

            <svg version="1.1" width="0" height="0">
              <defs>
                <pattern
                  id="patternUndecided"
                  width="8"
                  height="4"
                  patternUnits="userSpaceOnUse"
                  >
                  <line x1="0" y1="0" x2="8" y2="2" style="stroke:rgb(255,194,0);stroke-width:2.5" />
                </pattern>
              </defs>
            </svg>

            <svg version="1.1" width="0" height="0">
              <defs>
                <pattern
                  id="patternUndecidedRed"
                  width="8"
                  height="4"
                  patternUnits="userSpaceOnUse"
                  >
                  <line x1="0" y1="0" x2="8" y2="2" style="stroke:rgb(255,0,0);stroke-width:2.5" />
                </pattern>
              </defs>
            </svg>

            <svg version="1.1" width="0" height="0">
              <defs>
                <pattern
                  id="patternUndecidedGrey"
                  width="8"
                  height="4"
                  patternUnits="userSpaceOnUse"
                  >
                  <line x1="0" y1="0" x2="8" y2="2" style="stroke:rgb(128,128,128);stroke-width:2.5" />
                </pattern>
              </defs>
            </svg>

            <div class="">
              <table class="table table-borderless">
                <tr>
                  <td class="memTable"><span class="status status-green"></span>Paid</td>
                  <td class="tableVal">{{paidCount}}</td>
                </tr>
                <tr>
                  <td class="memTable"><span class="status status-Red"></span>Denied</td>
                  <td class="tableVal">{{declinedCount}}</td>
                </tr>
                <tr>
                  <td class="memTable"><span class="status status-blue"></span>Pending Coder Review</td>
                  <td class="tableVal">{{InprogressCount}}</td>
                </tr>
                <!-- <tr>
                <td class="memTable"><span class="status-line"></span>Provider Feedback</td>
                <td>{{providerfeedbackCount}}</td>
              </tr> -->
              <tr>
                <td class="memTable"><span class="status status-lightGreen"></span>Payment Approved</td>
                <td class="tableVal">{{approvedCount}}</td>
              </tr>
              <tr>
                <td class="memTable"><span class="status status-grey"></span>Not Received</td>
                <td class="tableVal">{{notReceivedCount}}</td>
              </tr>

              <tr>
                <td class="memTable"><span class="status-line-Red"></span>On Hold - Missing claim</td>
                <td class="tableVal">{{onHoldMissingClaimCount}}</td>
              </tr>
              <!-- <tr>
              <td class="memTable"><span class="status-line"></span>Paper PAHAF In Progress</td>
              <td class="tableVal">{{paperInProgressCount}}</td>
            </tr> -->
            <tr>
              <td class="memTable"><span class="status-line-grey1"></span>Portal In Progress</td>
              <td class="tableVal">{{partiallyCompletedCount}}</td>
            </tr>            
            <tr>
              <td class="memTable"><span class="status-line-Orange"></span>On Hold - Non-AWV Claim</td>
              <td class="tableVal">{{onHoldNonAWVClaimCount}}</td>
            </tr>

            <tr>
              <td class="memTable"><span></span>Total Members Count</td>
              <td class="tableVal">{{totalStatusCount}}</td>
            </tr>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>
</div>


<!-- <div class="container">
<button id ="btn" (click)="deletedata()"> Close </button>
</div>   -->

<div class="container">
  <div class="row">
    <div class="col text-center">
      <button class="btn green" style="margin-top: 4px;" (click)="deletedata()">Clear</button>
    </div>
  </div>
</div>




